export const BIZ_CLIENT_DEFAULT_SOURCE = "void";
export const CLIENTS_PAGE_DEFAULT_VIEW_MODE: "list" | "board" = "list";
export const CLIENTS_BOARD_CONFIG = {
  useHandle: false,
  mouseDragActivationDelay: 150,
  touchDragActivationDelay: 150,
};
